export default class WorkflowNodeAction {
	/** @type {string | undefined} */
	#workflowId;

	constructor() {
		this.#workflowId = undefined;

		/** @type {string} */
		this.action = '';

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.wfaction_kid = undefined;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.node_kid = undefined;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.wf_kid = undefined;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.wfstate_kid = undefined;

		/** @type {import('@knitiv/api-client-javascript').KNode[]} */
		this.wfallocatorlist = [];

		/** @type {string} */
		this.wfcomment = '';
	}

	export() {
		return {
			action:          this.action,
			node_kid:        this.node_kid,
			wfstate_kid:     this.wfstate_kid,
			wfallocatorlist: this.wfallocatorlist,
			wfcomment:       this.wfcomment,
		};
	}

	/**
	 * @param {import('angular').IScope} scope
	 * @param {any} wf
	 */
	setScope(scope, wf) {
		scope.$watch(() => wf.wfcomment, () => {
			this.wfcomment = wf.wfcomment;
		});
	}
}
